import { render, staticRenderFns } from "./CollectedPopup.vue?vue&type=template&id=b9e8e83e&scoped=true&"
import script from "./CollectedPopup.vue?vue&type=script&lang=js&"
export * from "./CollectedPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e8e83e",
  null
  
)

export default component.exports